import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { createDraft, finishDraft } from 'immer';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowModelCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsUpdateModelCommand;
(function (NsUpdateModelCommand) {
    /** Command: 用于注册named factory */
    NsUpdateModelCommand.command = XFlowModelCommands.UPDATE_MODEL;
    /** hookName */
    NsUpdateModelCommand.hookKey = 'updateModel';
})(NsUpdateModelCommand || (NsUpdateModelCommand = {}));
let UpdateModelCommand = 
/** 创建节点命令 */
class UpdateModelCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.updateModel.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { updateModel, getModel, modelService } = handlerArgs;
                const model = yield getModel(modelService);
                const currentValue = model.getValue();
                const draft = createDraft(currentValue);
                yield updateModel(draft);
                const newValue = finishDraft(draft);
                model.setValue(newValue);
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    model.setValue(newValue);
                })));
                return { model, value: newValue };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], UpdateModelCommand.prototype, "contextProvider", void 0);
UpdateModelCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsUpdateModelCommand.command.id },
    })
    /** 创建节点命令 */
], UpdateModelCommand);
export { UpdateModelCommand };
export const execCmd = () => { };
//# sourceMappingURL=update-model.js.map